export const STATUS_INVOICE_ENUM = {
  ACTIVE: "Đang sử dụng",
  EXPIRED: "Hết hạn",
};
